import React from 'react';
import {ThemeProvider} from '@rneui/themed';

import config from '../../config';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import rewardsTheme from '../../theme/rewardsTheme';

import SearchScreen from './SearchScreen';
import SearchScreenLoyaltyEnabled from './SearchScreenLoyaltyEnabled';

/**
 * Started building the vertical tile for search results screen but its not
 * complete so hardcoded whats existing.
 *
 * To finish this will need design for the additional info that is brought up. e.g. additional brand info.
 */
// eslint-disable-next-line no-constant-condition
export default config.FF_LOYALTY_ENABLED && false
  ? (props: RouteNavigatorScreenProps<AppRoute.NEW_SEARCH>) => (
      <ThemeProvider theme={rewardsTheme}>
        <SearchScreenLoyaltyEnabled {...props} />
      </ThemeProvider>
    )
  : SearchScreen;
